module.exports = __webpack_public_path__ + "img/b8.4071266b.png";